// image key naming convention = PARENT_COMPONENT_[LOCATION]_[PURPOSE]
// PARENT_COMPONENT = can be a nested path, ex EMAIL_ENTRY_BANNER
// LOCATION (relative to the parent component)= HEADING, BODY, FOOTING
// PURPOSE = SUCCESS, WARNING, INFO, TOOLTIP, ICON
import CARD_CVV from '../media/images/card-cvv.png';
import CARD_IN_MAIL from '../media/images/card-in-mail.png';
import CARD_SHIELD from '../media/images/card-shield.png';
import CARD_SUCCESS from '../media/images/card-success.png';
import CARD_WAND from '../media/images/card-wand.png';

const MAPS = {
    ACTIVATION_HEADING_ICON: CARD_WAND,
    SET_PIN_HEADING_ICON: CARD_SHIELD,
    ACTIVATION_RESULT_HEADING_SUCCESS: CARD_SUCCESS,
    SET_PIN_RESULT_HEADING_SUCCESS: CARD_SUCCESS,
    ACTIVATION_CVV_TOOLTIP_ICON: CARD_CVV,
    VIRTUAL_CARD_PIN_SET_PROMPT_HEADING_ICON: CARD_IN_MAIL,
};

export const IMAGE_KEYS = {};
Object.keys(MAPS)
    .sort()
    .forEach((k) => {
        IMAGE_KEYS[k] = k;
    });

const imageLibrary = MAPS;
export default imageLibrary;
